import { type Context, createContext, type ReactNode, useContext } from 'react';
import type { Sentry } from './types';

export const SentryContext: Context<Sentry | null> = createContext<Sentry | null>(null);

export function SentryProvider({
  sentry,
  children,
}: {
  sentry: Sentry;
  children: ReactNode;
}): JSX.Element {
  return <SentryContext.Provider value={sentry}>{children}</SentryContext.Provider>;
}

export function useSentry(): Sentry {
  const context = useContext(SentryContext);

  if (context === null) {
    throw new Error('useSentry must be used within a SentryProvider. ');
  }

  return context;
}
